import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { HYDRATE } from "@/redux/reducers/hydration";

import { WeedfettiThemeName } from "@/components/Weedfetti/themes";

const MAXIMUM_INSTANCE_COUNT = 3;

export type Weedfetti = {
  id: string;
  colors?: string[];
  theme?: WeedfettiThemeName;
};

export type WeedfettiState = {
  instances: Weedfetti[];
};

export const initialState: WeedfettiState = {
  instances: [],
};

const weedfettiSlice = createSlice({
  extraReducers: (builder) => {
    /**
     * Ignore any hydration events after initial page load to preserve any
     * subsequent changes that have been made on the client.
     */
    builder.addCase(HYDRATE, () => {});
  },
  initialState,
  name: "weedfetti",
  reducers: {
    cleanup(state, action: PayloadAction<string>) {
      state.instances = state.instances.filter(
        (instance) => instance.id !== action.payload,
      );
    },
    launch(
      state,
      action: PayloadAction<{ colors?: string[]; theme?: WeedfettiThemeName }>,
    ) {
      if (state.instances.length < MAXIMUM_INSTANCE_COUNT) {
        state.instances.push({ id: createId(), ...action.payload });
      }
    },
  },
});

/**
 * Creates a random ten letter string for use as a unique-ish ID
 */
function createId() {
  return Math.random().toString(36).substring(10);
}

export const { launch, cleanup } = weedfettiSlice.actions;
export default weedfettiSlice.reducer;
